//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import Money from '@motionelements/money';

export default {
  name: 'SubscribePricesCards',
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
      getPlanBilledMonthly: 'subscription/getPlanBilledMonthly',
    }),
    activePlanSku: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    billedAnnuallyMonthlyPrice() {
      return Money(this.getPlanBilledYearly.priceMonthly).toFormat('$0,0');
    },
    billedAnnuallyYearlyPrice() {
      return Money(this.getPlanBilledYearly.price).toFormat('$0,0');
    },
    billedMonthlyPrice() {
      return Money(this.getPlanBilledMonthly.price).toFormat('$0,0');
    },
    savedPercentage() {
      return 100 - Math.round((Number(this.getPlanBilledYearly.priceMonthly.amount) * 100) / Number(this.getPlanBilledMonthly.priceMonthly.amount));
    },
  },
  methods: {
    setActivePlanSku(sku) {
      this.activePlanSku = sku;
    },
  },
};
